import React__default, { useRef, useCallback, useEffect } from 'react';

var GameControllersContentComponent = function (_a) {
    var children = _a.children;
    return React__default.createElement("div", { className: 'pgc-game-controllers-content' }, children);
};
var GameControllersContentScrollableContainer = function (_a) {
    var children = _a.children, hasScrollToBottom = _a.hasScrollToBottom;
    var scrollRef = useRef(null);
    var scrollToMyRef = useCallback(function () {
        if (!scrollRef.current)
            return;
        var scroll = scrollRef.current.scrollHeight - scrollRef.current.clientHeight;
        scrollRef.current.scrollTo(0, scroll);
    }, [scrollRef]);
    useEffect(function () {
        if (hasScrollToBottom) {
            scrollToMyRef();
        }
    }, [hasScrollToBottom, children]);
    return (React__default.createElement("div", { className: 'scroll-holder' },
        React__default.createElement("div", { className: 'scrollable-container', ref: scrollRef }, children)));
};
var GameControllersContent = Object.assign(GameControllersContentComponent, {
    ScrollableContainer: GameControllersContentScrollableContainer,
});

export { GameControllersContent };
